<template>
    <PowerDataBase :selectedLoops="selectedLoops" :real-data="realData" :options="options" :current-loop="currentLoop">
        
    </PowerDataBase>
    
</template>

<script>
    import Curve from "../../chart/Curve";
    import PowerDataBase from "./PowerDataBase";

    export default {
        name: "PowerData",
        components: {
            Curve,
            PowerDataBase
        },
        props: {
            currentLoop: Object,
            selectedLoops: Array
        },
        computed: {
            options() {
                if(this.routeName=='Classification'){
                    if(this.currentLoop.id=="30"){
                        return [{
                            value: 'electricity',
                            unit:"kWh",
                            label: '用电量'
                        },
                        {
                            value: 'water',
                            unit:"m³",
                            label: '用水量'
                        },{
                            value: 'heat',
                            unit:"GJ",
                            label: '用热量'
                        }
                        // ,{
                        //     value: 'cooling',
                        //     unit:"GJ",
                        //     label: '用冷量'
                        // }
                        ]
                    }else{
                        return [{
                            value: 'electricity',
                            unit:"kWh",
                            label: '用电量'
                        },
                        ]
                    }
                    
                }else{
                    return [{
                        value: 'AIR_CONDITIONER',
                        unit:"kWh",
                        label: '空调'
                    },
                    {
                        value: 'LIGHTING',
                        unit:"kWh",
                        label: '照明'
                    },{
                        value: 'POWER',
                        unit:"kWh",
                        label: '动力'
                    }
                    ]
                }
                

            },
            tag() {
                return this.$route.params.tag
            },
            routeName() {
                return this.$route.params.name
            },
            realData() {

            }
        },
        data() {
            return {
                node: "",
                date: new Date(),
                diagramSelected: 0,

            }
        },
        methods: {
            
        }
    }
</script>

<style scoped lang="less">
    .transformer {
        width: 100%;
        height: 100%;

        span {
            font-size: 18rem;
            font-weight: bold;
        }

        >div {
            margin-right: 72rem;
        }

        .k {
            color: #333333;
            margin-right: 18rem;
        }

        .v {
            color: #0D94FF;
        }
    }

    .breaker {
        width: 100%;
        height: 100%;
        // background-color: rgba(0, 43, 102, 0.04);
        padding-left: 8rem;

        span {
            font-size: 18rem;
            font-weight: bold;
        }

        .k {
            color: #333333;
            margin-right: 24rem;
        }

        .v {
            color: red;
            ;
        }

        .Handcart {
            color: #0D94FF;
        }

        .sate {
            padding-left: 325rem;
        }
    }
</style>